export * from './access-denied/access-denied.component';
